import BaseModel from "./base/baseModel";
import CstIBSCBS from "./enum/cstIBSCBS";
import TiposMovimentacao from "./enum/tiposMovimentacao";
import NaturezaOperacaoFinalidadeEmissaoModel from "./naturezaOperacaoFinalidadeEmissaoModel";
import NaturezaOperacaoObservacaoModel from "./naturezaOperacaoObservacaoModel";

export default class NaturezaOperacaoModel extends BaseModel {
    id?: number = null;
    codigo = 0;
    descricao: string = null;
    tipoMovimentacao: TiposMovimentacao = null;
    dentroEstado = false;
    movimentaEstoque = false;
    usaConfiguracaoFiscal = false;
    transferencia = false;
    cstICMS: number = null;
    aliquotaICMS: number = null;
    cstIPI: number = null;
    aliquotaIPI: number = null;
    cstPIS: number = null;
    aliquotaPIS: number = null;
    aliquotaCOFINS: number = null;
    cstCOFINS: number = null;
    cstIBSCBS: CstIBSCBS = null;
    classificacaoTributaria: string = null;
    codigoBeneficio: string = null;
    observacao: string = null;
    simplesRemessa?: boolean = false;
    ativo?: boolean = true;
    importacao = false;
    observacoes: Array<NaturezaOperacaoObservacaoModel> = [];
    consumidorFinal: boolean = false;
    finalidadesEmissao: Array<NaturezaOperacaoFinalidadeEmissaoModel> = [];
}
